// extracted by mini-css-extract-plugin
export default {"button":"CodeInput_button__KcG6L","input":"CodeInput_input__AZYAE"};